import { useSuspenseQuery, useQueryClient } from '@tanstack/react-query';
import queryKeys from '../../support/uiStateKeys';

const dataKeys = [queryKeys.REMOVE_QUERY_ON_MODAL_CLOSE, queryKeys.NOTES];
/**
 * useNotes returns the notes that the user has entered for their download.
 *
 * @returns {{ notes: string, setNotes: function }}
 */
const useNotes = () => {
  const queryClient = useQueryClient();
  // useQuery by default returns a data object that represents the value stored in the queryKey
  const { data } = useSuspenseQuery({
    queryKey: dataKeys,
    queryFn: ({ queryKey }) => queryClient.getQueryData(queryKey),
    initialData: '',
  });

  const setNotes = (notes) => {
    // for data that is not directly bound to an api call we can use the query client and manually call setQueryData
    queryClient.setQueryData(dataKeys, notes);
  };

  return {
    notes: data,
    setNotes,
  };
};

export default useNotes;
